var $          = require('./$')
  , createDesc = require('./$.property-desc');
module.exports = require('./$.support-desc') ? function(object, key, value){
  return $.setDesc(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/$.hide.js
 **/